import React, {PureComponent} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {size380x380} from 'app/utils/CasinoGameImages';
import {isGuest} from 'app/utils';
import {captureCasinoGameLaunchRow, startCasino, startCasinoGame} from 'app/services/CasinoServices';
import {SignInButton} from 'app/components/auth/SignInButton';
import type {BigWinInterface} from 'app/interfaces/stores/CasinoGamesStoreInterfaces';

interface CasinoRecordWinProps {
    biggestWin: BigWinInterface;
    style?: React.CSSProperties;
}

export default class CasinoRecordWin extends PureComponent<CasinoRecordWinProps> {
    rootElement = React.createRef<HTMLDivElement>();

    handlePlayClick = (): void => {
        const {biggestWin} = this.props;

        if (biggestWin?.game_id) {
            startCasinoGame(biggestWin.game_id, null, this.rootElement.current);
        }
    };

    handleDemoClick = (): void => {
        const {biggestWin} = this.props;

        if (biggestWin?.game_id) {
            captureCasinoGameLaunchRow(this.rootElement.current);
            startCasino(biggestWin.game_id, null, true);
        }
    };

    render(): React.ReactNode {
        const {biggestWin} = this.props;

        if (!biggestWin) {
            return null;
        }

        const {amount, identifier, provider_name, in_out, image_url} = biggestWin;
        const [integerPart, fractionalPart] = String(amount ?? '').split('.');

        const {style} = this.props as CasinoRecordWinProps;

        return <div ref={this.rootElement} className="casino-record-win marketing-block" style={style}>
            <div className="casino-record-win__content">
                <div className="casino-record-win__header">
                    <SpriteIcon
                        name="#svg-bag-of-money"
                        className="casino-record-win__icon svg-default"
                        size={{height: 20, width: 20}}
                    />
                    <span className="casino-record-win__title">
                        {I18n.t('record_win')}
                    </span>
                </div>
                <div className="casino-record-win__amount">
                    ${integerPart}
                    {fractionalPart && <span className="casino-record-win__amount-fractional">.{fractionalPart}</span>}
                </div>
                <div className="casino-record-win__buttons">
                    {isGuest()
                        ? <>
                            <SignInButton
                                title={I18n.t('play')}
                                usingOnTab="CASINO"
                                className="casino-record-win__button"
                            />
                            <SignInButton
                                usingOnTab="CASINO"
                                className="casino-record-win__button casino-record-win__button_demo"
                            >
                                <SpriteIcon name="#svg-button-eye" className="svg-default"/>
                            </SignInButton>
                        </>
                        : <>
                            <button
                                type="button"
                                onClick={this.handlePlayClick}
                                className="casino-record-win__button"
                            >
                                {I18n.t('play')}
                            </button>
                            <button
                                type="button"
                                onClick={this.handleDemoClick}
                                className="casino-record-win__button casino-record-win__button_demo"
                            >
                                <SpriteIcon name="#svg-button-eye" className="svg-default"/>
                            </button>
                        </>}
                </div>
            </div>
            <div className="casino-record-win__game">
                <img
                    src={size380x380(
                        provider_name,
                        identifier,
                        biggestWin.released_at,
                        in_out,
                        image_url
                    )}
                    alt={`record win ${identifier}`}
                    className="casino-record-win__game-img"
                />
            </div>
        </div>;
    }
}
